import { usePinFilters } from "@/lib/pins-context";
import { X } from "lucide-react";
import type { PinEntityType } from "@dugads/shared";

interface PinFilterBarProps {
  entityType: PinEntityType;
}

export function PinFilterBar({ entityType }: PinFilterBarProps) {
  const { pins, activePinIds, togglePinFilter, clearPinFilters } = usePinFilters();

  const activePins = pins.filter(
    (p) => activePinIds.has(p.id) && p.entity_type === entityType,
  );

  if (activePins.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-muted-foreground">Filtered by:</span>
      {activePins.map((pin) => (
        <span
          key={pin.id}
          className="inline-flex items-center gap-1 rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary"
        >
          {pin.entity_name}
          <button
            type="button"
            onClick={() => togglePinFilter(pin.id)}
            className="hover:text-destructive"
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      {activePins.length > 1 && (
        <button
          type="button"
          onClick={clearPinFilters}
          className="text-xs text-muted-foreground hover:text-foreground"
        >
          Clear all
        </button>
      )}
    </div>
  );
}
